import type { OrbitResponseDto } from '@lunary/api-client'

export function orbitComplete(data: OrbitResponseDto, guest: boolean): boolean {
  return !!data.day_card && data.day_card_opened && !guest && !!data.personal_arcana && !!data.pick
}
